import {useAuth} from "base/auth";

import {EntityGeneralDataSection} from "base/entity";

const VertidoGeneralDataSection = ({vertido}) => {
    const {ROLES} = useAuth();

    const sections = [
        /*
        {
            label: "Código externo",
            value: vertido.codigo_externo,
        },
        */
        {
            label: "Concello",
            value: vertido.concello_label,
            linkPath: `/concellos/${vertido.concello}`,
        },
        {
            label: "Aglomeración",
            value: vertido.aglomeracion_label,
            linkPath: `/aglomeracions/${vertido.aglomeracion}/summary`,
        },
        {
            label: "Bacía",
            value: vertido.masa_auga_label,
            linkPath: `/medioreceptor/masaauga/${vertido.masa_auga}/principal`,
        },
        {
            label: "Sistema de explotación",
            value: vertido.sistema_explotacion_label,
            linkPath: `/medioreceptor/sistemaexplotacion/${vertido.sistema_explotacion}`,
        },
        {
            label: "Titular", 
            value: vertido.administracion_titular_label, 
            tooltipText: "Administración pública que ten a titularidade da infraestrutura dacordo os termos establecido na LEI 1/2022, do 12 de xullo, de mellora da xestión do ciclo integral da auga."
        },

    ];

    return (
        <>
            <EntityGeneralDataSection
                featured_image={vertido.featured_image}
                featured_document={vertido.featured_document}
                name={
                    vertido.codigo ? `Código: ${vertido.codigo}` : `ID: ${vertido.id}`
                }
                sections={sections}
            />
        </>
    );
};

export default VertidoGeneralDataSection;
